import { render } from "./ChangeArticle.vue?vue&type=template&id=2d5936d5"
import script from "./ChangeArticle.vue?vue&type=script&lang=js"
export * from "./ChangeArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__